(() => {
  const formatMoney = (cents, fallback) => {
    if (typeof cents !== 'number') return fallback;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
      }).format(cents / 100);
    } catch (_) {
      return fallback;
    }
  };

  const initPicker = (root) => {
    const jsonEl = root.querySelector('[data-variant-json]');
    if (!jsonEl) return;
    let variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (_) { return; }

    const groups = Array.from(root.querySelectorAll('[data-option-index]'));
    const getSelection = () => groups.map((group) => {
      const active = group.querySelector('.siliane-swatch[aria-checked="true"]');
      return active ? active.dataset.optionValue : null;
    });

    const matchVariant = (selection) => variants.find((v) => {
      const opts = [v.option1, v.option2, v.option3];
      return selection.every((val, i) => val === null || opts[i] === val);
    });

    // Find the product-form + price wrapper anywhere in the same section (or document).
    const section = root.closest('.shopify-section') || document;

    const update = () => {
      const variant = matchVariant(getSelection());
      if (!variant) return;

      // Update variant id inputs within same section.
      section.querySelectorAll('[data-product-variant-id]').forEach((input) => {
        input.value = variant.id;
        if (variant.available) input.removeAttribute('disabled');
        else input.setAttribute('disabled', '');
      });

      // Update price display.
      section.querySelectorAll('[data-price-wrapper]').forEach((wrap) => {
        const cur = wrap.querySelector('[data-price-current]');
        if (cur) cur.textContent = formatMoney(variant.price, cur.textContent);
        const cmp = wrap.querySelector('[data-price-compare]');
        if (cmp) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            cmp.textContent = formatMoney(variant.compare_at_price, cmp.textContent);
            cmp.hidden = false;
          } else {
            cmp.hidden = true;
          }
        }
      });

      // Update submit button state + label.
      section.querySelectorAll('[data-product-submit]').forEach((btn) => {
        const lbl = btn.querySelector('[data-submit-label]');
        if (variant.available) {
          btn.removeAttribute('disabled');
          if (lbl && lbl.dataset.originalLabel) lbl.textContent = lbl.dataset.originalLabel;
        } else {
          btn.setAttribute('disabled', '');
          if (lbl) {
            if (!lbl.dataset.originalLabel) lbl.dataset.originalLabel = lbl.textContent.trim();
            lbl.textContent = 'Rupture de stock';
          }
        }
      });

      // Update URL without reload.
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Update selected-value label in picker legends.
      groups.forEach((group, i) => {
        const vlabel = group.querySelector('[data-option-selected-value]');
        if (vlabel) {
          const opts = [variant.option1, variant.option2, variant.option3];
          vlabel.textContent = opts[i] || '';
        }
      });
    };

    root.addEventListener('click', (e) => {
      const sw = e.target.closest('.siliane-swatch');
      if (!sw) return;
      const group = sw.closest('[data-option-index]');
      if (!group) return;
      group.querySelectorAll('.siliane-swatch').forEach((el) => {
        el.setAttribute('aria-checked', el === sw ? 'true' : 'false');
      });
      update();
    });

  };

  // Register a minimal custom element for semantic marker (no shadow DOM).
  if (!customElements.get('product-form')) {
    customElements.define('product-form', class extends HTMLElement {});
  }

  const bindQty = (qty) => {
    if (qty.dataset.qtyBound === '1') return;
    qty.dataset.qtyBound = '1';
    const input = qty.querySelector('[data-qty-input]');
    if (!input) return;
    qty.querySelector('[data-qty-decrement]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    qty.querySelector('[data-qty-increment]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  document.querySelectorAll('[data-variant-picker]').forEach(initPicker);
  document.querySelectorAll('[data-qty]').forEach(bindQty);
})();
